// extracted by mini-css-extract-plugin
export default {"meausreTableOuter":"measure_meausreTableOuter__-UC7H","screenedTableOuter":"measure_screenedTableOuter__kvRM5","alarmTableOuter":"measure_alarmTableOuter__2rqQA"};